
import DateUtils from '@core/utils/date/DateUtils';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import JackpotBanner, { Level } from '@models/games/JackpotBanner';
import IJackpotBannerDto from './dtos/IJackpotBannerDto';

export default class JackpotBannerMapper extends AbstractMapper<IJackpotBannerDto, JackpotBanner> {

    getLevel(): Level {
        const level = new Level();
        return level;
    }

    createTargetObject(dto: any): JackpotBanner {
        const jackpotBanner = new JackpotBanner();
        jackpotBanner.levels = [];
        jackpotBanner.currency = dto.currency;

        const createLevel = (levelSufix: string) => {
            // all money values are divided wih 100
            // API returns integer, and we need to cast it into decimal
            // e.g. cast 37051 into 370.51
            const level = new Level();
            level.currentAmount = dto[`currentLevel${levelSufix}`] / 100;
            level.highestWinningAmount = dto[`largestWinLevel${levelSufix}`] / 100;
            level.highestWinningDate = DateUtils.toDate(dto[`largestWinDateLevel${levelSufix}`]);
            level.latestWinningAmount = dto[`lastWinLevel${levelSufix}`] / 100;
            level.latestWinningDate = DateUtils.toDate(dto[`lastWinDateLevel${levelSufix}`]);
            level.latestWinningPlayer = dto[`lastWinUserLevel${levelSufix}`];
            level.numberOfWins = dto[`winsLevel${levelSufix}`];
            return level;
        };

        jackpotBanner.levels.push(createLevel('I'));
        jackpotBanner.levels.push(createLevel('II'));
        jackpotBanner.levels.push(createLevel('III'));
        jackpotBanner.levels.push(createLevel('IV'));

        return jackpotBanner;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/game/JackpotBannerMapper.ts